import { useState } from 'react';
import { cancelApproval } from '../../api/approval';
import { notifyError } from '../../utils/notify';
import { notifyApprovalInboxChanged } from '../../utils/approvalInboxBadge';
import { ApprovalPendingFields } from '../../utils/approvalPending';

interface Props {
  detail: ApprovalPendingFields | null | undefined;
  className?: string;
  disabled?: boolean;
  onCancelled: () => void | Promise<void>;
}

/** 기안자용 결재 요청 취소 버튼 */
function ApprovalCancelButton({ detail, className, disabled, onCancelled }: Props) {
  const [busy, setBusy] = useState(false);
  if (!detail?.canCancelApproval || !detail.pendingApprovalRequestId) {
    return null;
  }

  return (
    <button
      type="button"
      className={className}
      disabled={disabled || busy}
      onClick={() => {
        void (async () => {
          if (!window.confirm('결재 요청을 취소할까요? 취소 후 수정·다시 결재 요청할 수 있습니다.')) {
            return;
          }
          try {
            setBusy(true);
            await cancelApproval(detail.pendingApprovalRequestId!);
            notifyApprovalInboxChanged();
            await onCancelled();
          } catch (err) {
            notifyError(
              (err as { response?: { data?: { message?: string } } })?.response?.data?.message ??
                '결재 요청 취소에 실패했습니다.'
            );
          } finally {
            setBusy(false);
          }
        })();
      }}
    >
      {busy ? '취소 중...' : '결재 요청 취소'}
    </button>
  );
}

export default ApprovalCancelButton;
